import styled from "styled-components";

export const Container = styled.div`
  background-color: #08559f;
  width: 100%;
  height: 100%;
`;

export const HeaderLogin = styled.div`
  div {
    background-color: #fff;
    border-radius: 0px 0px 30px 30px;
    display: flex;
    justify-content: center;
    box-shadow: 2px 2px 8px 0px #00000030;
  }

  img {
    width: 250px;
    margin: 20px 0px 10px 0px;
  }
`;

export const FormLogin = styled.div`
  width: 100%;
  margin-top: 30px;
  padding: 80px 30px 0px 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    /* margin-top: 25px; */
    margin-bottom: 15px;
    text-align: center;
  }
`;

export const ButtonSend = styled.div`
  margin-top: 25px;
`;
export const ButtonBack = styled.div`
  margin: 130px 0px 0px 0px;
  z-index: 99;
`;

export const Alert = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
